export const errorCodeMap = {
    NOT_LOGIN: 40100001,
    NOT_LOGIN_STR: 'userNotLogin',
    FILENAME_CHECK_FAILED: 40010012,
    FILENAME_CHECK_FAILED_STR: '40010012',
    NOT_COMPANY_USER_1_STR: '40310008',
    NOT_COMPANY_USER__2_STR: '40010005',
    COMPANY_NOT_CERTIFY: 40010010,
    NOT_COMPANY_CHECK_FAILED: 40010009,
    COMMPANY_PACKAGE_FAILED: 40310007,
    FILETYPE_NOT_SUPPORT: 40010003,
    AUTH_CHECK_FAILED: 40010013,//违规
    WAIT_M_CHECK: 40010014,//机审中
    WAIT_P_CHECK: 40010015,//人工审核中
    COMMPANY_PACKAGE_EXPIRED: 40310005 //企业套餐过期
}
